import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'

import EditIcon from '../../../../icons/edit.svg'

function EntityProfileHeaderTextButton({
  className,
  isMeasure = false,
  qaName,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: EditIcon }}
      className={className}
      height={BUTTON_HEIGHT_32}
      qaName={isMeasure ? undefined : qaName}
      tabIndex={isMeasure ? -1 : undefined}
      tooltip={isMeasure ? undefined : t('Profile.EditBtnKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={isMeasure ? undefined : onClick}
    />
  )
}

export default EntityProfileHeaderTextButton
